export const chartDataKeyPrefix = ["widgetsChartData"];
